export const chartDataKeyPrefix = ["widgetsChartData"];
